<template>
  <div v-if="loading">
    Loading invoices from store...
  </div>
  <div v-else style="width:100%;">
     <div class="debug">
        <p>header = {{ header }}</p>
        <p>tableData.length = {{ tableData.length }}</p>
        <p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>
    </div>
  <FilterTable
    :header="header"
    :data="invoiceTableData"
    :columnWidths="colWidths"
  
    @rowClicked="printRow"
    v-model:filtered="filtered"
    v-model:search="search"
  >
  </FilterTable>

  <!--div class="btn-row-left">
    <FormBtn v-if="currentGroup === 'admin' || currentGroup === 'standard'" :name="'Download all Invoices'" @clicked="downloadAllInvoices"></FormBtn>
    <FormBtn :name="'Refresh Table'" @clicked="invoices.fetchAllInvoices"></FormBtn>
  </div-->
  <div class="btn-row-left">
    <FormBtn v-if="currentGroup === 'admin' || currentGroup === 'standard'" :name="'Download Report'" @clicked="downloadReport"></FormBtn>
  </div>
  </div>
 
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue'
import { useInvoiceStore, useUserStore } from '@/stores'
import type { Invoice } from '@/types/types'
import router from '@/router'
import { FormBtn } from '@/components/form'
import { FilterTable } from '@/components'
import { useInvoiceTableFilter } from '@/composables/Invoice-table-filter'
import { useAllCsvDownload } from '@/composables/All-csv-download'
import { invoiceSchema, invoiceReportSchema } from '@/types/types'
import { storeToRefs } from 'pinia'

const invoices = useInvoiceStore()
const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const { tableData } = storeToRefs(invoices);
//const allInvoices = ref<Array<Invoice>>([])
const header = ['id', 'projectId', 'customerName', 'value_total', 'datePaid', 'owner', 'engineer']
const colWidths = [8, 8, 30]

//await getInvoices()

const loading = computed(()=>{
  return invoices.loading;
})
/*
const invoiceTableData = computed(()=>{
  return JSON.parse(JSON.stringify(tableData.value));
})*/
const invoiceTableData = ref([]);
invoiceTableData.value = await invoices.fetchTableData();


//const filteredCustomers = ref(allCustomers.value);
let searchJson = {}
header?.forEach((col) => {
  searchJson[col] = ''
})
const search = ref(searchJson)
const { filtered } = useInvoiceTableFilter(invoiceTableData, search)

const invoicesHeader = [
  'id',
  'created_on',
  'created_by',
  'modified_on',
  'address',
  'projectId',
  'province',
  'taxRate',
  'customer_id',
  'valueTotal',
  'taxTotal',
  'datePaid',
  'owner',
  'engineer',
  'lineItems'
]


//add projectCount field to customerSchema
const { downloadAllCsv } = useAllCsvDownload(
  invoiceTableData,
  invoiceSchema,
  invoicesHeader,
  'Invoices'
)

const reportHeader = [
  'source', 'project id', 'project name', 'customer', 'invoice id', 'invoice value', 'one off'
]

//const { downloadInvoiceReport } = useAllCsvDownload( reportData, invoiceReportSchema, reportHeader, 'Invoice Report')

async function downloadAllInvoices(){
  await invoices.fetchAllInvoices()
  await downloadAllCsv();
}

async function downloadReport(){
  await invoices.getReport();
  //console.log("report downloaded : " + JSON.stringify(report));
}
/*
async function forceFetchInvoices(){
  console.log("Invoices-table.forceFetchInvoices...");
  await invoices.fetchAll();
  //const mapped = await parseTableData(data);
  //allInvoices.value = mapped;
}*/
/*
async function getInvoices() {
  console.log('Invoices-table.getInvoices()...')
  const data = await invoices.getAll()
  const mapped = await parseTableData(data);
  allInvoices.value = mapped;
}*/

/*
async function parseTableData(data){
  const mapped = data.map((inv) => {
    let temp = inv;
    try{
      temp.customerName = inv.customer.invoiceName;
    } catch (err){
      console.error("..trapped error mapping customerName on Invoice-table.parseTableData...")
      console.error("inv = " + JSON.stringify(inv));
      temp.customerName = 'empty';
    }
    let formattedDate = inv.datePaid != null ? new Date(inv.datePaid).toLocaleDateString() : null
    temp.datePaid = formattedDate
    return temp;
  });
  return mapped;
}
*/


function printRow(item: Invoice) {
  console.log('printRow..')
  console.log(JSON.stringify(item))
  //console.log("...pushing router to project_details");
  router.push(`/projects/${item.projectId.toString()}/invoices/${item.id?.toString()}`)
}
</script>
